export class PROD {
    Type: string = "PROD";
    SerialNumber: string;
    DeviceId: string;
    ProdDataInici: Date;
    ProdDataFi: Date;
    StatusPiece : number;
    TotalSteps :number;
    TimeSinceLastPiece: number;
    Duration: number;
    Quantity: number;

    TotalPiecesOK: number;
    TotalPiecesNG: number;
    DailyTotalPiecesOK: number;
    DailyTotalPiecesNG: number;

    DailyProduction: any;

    ReferenceProduction: any;
    ReferenceProductionNOK: any;
    Cadence: number;
    Oee: any;
    ExpectedCadence: number;
}